import {Image, SectionIntro} from '@primer/react-brand/esm'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import PlanCard, {type PlanCardProps} from '../../../../../brand/components/PlanCard/PlanCard'

import Spacer from '../../components/Spacer/Spacer'

import imgBgDesktop from './pricing-bg-desktop.webp'
import imgBgMobile from './pricing-bg-mobile.webp'

import COPY from './Pricing.data'
import Styles from './Pricing.module.css'

export interface PricingProps {
  intro: {
    title: string
    description: string
    iconUrl: string
    link: {
      href: string
      text: string
    }
  }
  plans: PlanCardProps[]
}

const defaultProps: Partial<PricingProps> = {}

const Pricing: React.FC<PricingProps> = props => {
  const initializedProps = {...defaultProps, ...props}

  const {
    intro: {title, description, iconUrl, link},
    plans,
  } = initializedProps

  return (
    <section
      id="pricing"
      className={Styles.Pricing}
      style={{
        ['--bg-desktop']: `url("${imgBgDesktop}")`,
        ['--bg-mobile']: `url("${imgBgMobile}")`,
      }}
    >
      {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
      <div className="lp-Container">
        <Spacer size="64px" size768="182px" />

        <div className={Styles.PricingIcon}>
          <Image src={iconUrl} alt="" width={112} loading="lazy" />
        </div>

        <Spacer size="32px" size768="48px" />

        <SectionIntro align="center" fullWidth style={{padding: '0'}}>
          <SectionIntro.Heading as="h2" size="3">
            {title}
          </SectionIntro.Heading>

          <SectionIntro.Description className={Styles.SectionIntroDescription}>{description}</SectionIntro.Description>

          <SectionIntro.Link
            href={link.href}
            className={Styles.SectionIntroLink}
            {...getAnalyticsEvent(COPY.link.analytics.marketingAnalyticsEvent)}
          >
            {link.text}
          </SectionIntro.Link>
        </SectionIntro>

        <Spacer size="64px" size768="88px" />

        <div className={Styles.PricingPlans}>
          {plans.map((plan, index) => (
            <PlanCard
              // eslint-disable-next-line @eslint-react/no-array-index-key
              key={`plan_${index}`}
              {...plan}
              cta1={{...plan.cta1, analytics: COPY.plans[index]?.cta1.analytics}}
            />
          ))}
        </div>

        <Spacer size="96px" size768="322px" />
      </div>
    </section>
  )
}

export default Pricing
